exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-details__header{text-align:center}.user-details__header .thumbnail{width:5rem;height:5rem;padding:1.125rem;margin:0 auto;margin-bottom:.75rem}.user-details__header .modal__buttons{padding-top:.75rem}.user-details__last-accessed span,.user-details__role span{color:#374651}.user-details__last-accessed{margin-top:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/UserDetails/UserDetails.scss
// module id = 694
// module chunks = 0